"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskyMerchantsRangeRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.RiskyMerchantsRangeRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.risky_merchants_range.label',
    fallbackLabel: 'Risky merchants ranges',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'BELOW_1', label: 'fields.enm.risky_merchants_range.options.BELOW_1', fallbackLabel: '< 1%' },
        { key: 'BELOW_5', label: 'fields.enm.risky_merchants_range.options.BELOW_5', fallbackLabel: '< 5%' },
        { key: 'BELOW_10', label: 'fields.enm.risky_merchants_range.options.BELOW_10', fallbackLabel: '< 10%' },
        { key: 'ABOVE_10', label: 'fields.enm.risky_merchants_range.options.ABOVE_10', fallbackLabel: '> 10%' },
    ],
    trackFieldValueWithAnalytics: false,
};
